import UnitsDataView from "./UnitsDataView";
import SydFilterView from "src/components/Common/UI/SydFilter/SydFilterView";
import SydFilterProvider from "src/components/Common/UI/SydFilter/SydFilterContext";
import SearchUnit from "./SearchUnit";


const defaultFilterData: IUnitSearchForm = {
  description: "",
  sapCode: "",
  unID: "",
  deleted: "",
  placeID: ""
}

const Units = () => {
  
  return (
    <SydFilterProvider
      defaultFilterData={defaultFilterData}
    >
      <SydFilterView title={"Αναζήτηση Μονάδας"}>
        <SearchUnit />
      </SydFilterView>
      <UnitsDataView />
    </SydFilterProvider>
  )

}
export default Units;